import session from '../../../../share/session';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import { REQUEST_STATUS_COMPLETED, REQUEST_STATUS_FAILED } from '../../../../share/util/api/polling';
import error from '../../../../common/nodejs/errors';
import { PHASE } from './constants';

/**
 * API通信共通処理
 * @param {object} self 呼び出し元インスタンス
 * @param {string} type リクエストのtype
 * @param {async () => {}} completedCallback status: completed のときのコールバック関数
 * @param {async () => {}} failedCallback status: failed のときのコールバック関数
 */
export async function executeApi(self, type, completedCallback,
  failedCallback = async (self) => { self.showUnexpectedError(); }
) {
  try {
    self.isLoading = true;
    const token = session.getToken();
    // データ読み出し(要求)（バックエンドAPI_POST）
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: type,
      },
      //  エラー発生のコールバックを実装
      // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
      (errorType) => { errorType; self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      (result) => { self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      (result) => { self.validateErrorResult(result); },
    );

    if (!response) return;

    switch (response.data.status) {
      // 正常終了
      case REQUEST_STATUS_COMPLETED:
        await completedCallback(self, response);
        break;
      // 異常終了
      case REQUEST_STATUS_FAILED:
        // type: write_session_transition の場合のみ、NonDefaultSession遷移の結果を保持しておく
        if (type === 'write_session_transition') {
          self.isDispose = Boolean(response.data?.user_data?.is_dispose);
        }
        await failedCallback(self, response);
        break;
      default:
        self.showUnexpectedError();
        break;
    }
  } finally {
    self.isLoading = false;
  }
}

/**
 * resultを確認する場合のstatus === 'completed' 時共通処理
 * @param {object} self 呼び出し元インスタンス
 * @param {object} response APIレスポンス
 * @param {async () => {}} okResultCallback result: ok のときのコールバック関数
 * @param {async () => {}} retryResultCallback result: retry のときのコールバック関数
 */
export async function handleResponseResult(self, response, okResultCallback, retryResultCallback) {
  switch (response.data.user_data.result) {
    case 'ok':
      await okResultCallback(self);
      break;
    case 'retry':
      await retryResultCallback(self);
      break;
    default:
      self.showUnexpectedError();
      break;
  }
}

/**
 * status === 'failed' 時にasync_codeを確認する場合の共通処理
 * @param {object} self 呼び出し元インスタンス
 * @param {object} response APIレスポンス
 * @param {async () => {}} okResultCallback result: ok のときのコールバック関数
 * @param {async () => {}} ngResultCallback result: retry のときのコールバック関数
 */
export async function handleResponseFailed(self, response) {
  // async_codeが存在しない場合共通エラー
  if (!response.data.async_code) {
    self.showUnexpectedError();
    return;
  }

  switch (response.data.async_code) {
    case error.WSP_142_EXECUTE_FAILED:
      await executeApi(self, self.isDispose ? 'dispose' : 'exit',
        // 結果に関わらずエラー画面を表示
        (self) => { self.phase = PHASE.ERROR; },
        (self) => { self.phase = PHASE.ERROR; }
      );
      break;
    case error.WSP_GENERAL_ERROR:
    default:
      self.showUnexpectedError();
      break;
  }
}